import React from "react";
import { TransportTypeEnum } from "../../states/app-state"
import { useThemeMode } from "../../states/contexts/theme"; //  added by Bearer Web Developer 

export default function TransportTypeImage(props: { type: TransportTypeEnum, orange?: boolean }) { // orange property added by Bearer Web Developer
    const { theme } = useThemeMode(); //  added by Bearer Web Developer 
    // modified by Bearer Web Developer start
    if (props.type === TransportTypeEnum.riding) {
        // added by Bearer Web Developer start
        if (theme === "dark" && !props?.orange) {
            return <img src="/motorcycle-white.svg" alt="motorcycle" width={50} height={50} />
        }
        // added by Bearer Web Developer end
        return <img src="/motorcycle.png" alt="motorcycle" width={50} height={50} /> //  modified by Bearer Web Developer
    }
    else if (props.type === TransportTypeEnum.cycling) {
        // added by Bearer Web Developer start
        if (theme === "dark" && !props?.orange) {
            return <img src="/pedal-bike-white.svg" alt="pedal bike" width={50} height={50} />
        }
        // added by Bearer Web Developer end
        return <img src="/pedal-bike.png" alt="pedal bike" width={50} height={50} /> //  modified by Bearer Web Developer
    }
    else if (props.type === TransportTypeEnum.walking) {
        // added by Bearer Web Developer start
        if (theme === "dark" && !props?.orange) {
            return <img src="/directions-run-white.svg" alt="directions run" width={50} height={50} />
        }
        // added by Bearer Web Developer end
        return <img src="/directions-run.png" alt="directions run" width={50} height={50} /> //  modified by Bearer Web Developer
    }
    //  added by Bearer Web Developer start
    else if (props.type === TransportTypeEnum.driving) {
        // added by Bearer Web Developer start
        if (theme === "dark" && !props?.orange) {
            return <img src="/car-white.svg" alt="car" width={50} height={50} />
        }
        // added by Bearer Web Developer end
        return <img src="/car.webp" alt="car" width={50} height={50} />
    }
    else if (props.type === TransportTypeEnum.drone) {
        // added by Bearer Web Developer start
        if (theme === "dark" && !props?.orange) {
            return <img src="/drone-white.svg" alt="drone" width={50} height={50} />
        }
        // added by Bearer Web Developer end
        return <img src="/drone.webp" alt="drone" width={50} height={50} />
    }
    else if (props.type === TransportTypeEnum.rover) {
        // added by Bearer Web Developer start
        if (theme === "dark" && !props?.orange) {
            return <img src="/rover-white.svg" alt="rover" width={50} height={50} />
        }
        // added by Bearer Web Developer end
        return <img src="/rover.webp" alt="rover" width={50} height={50} />
    }
    //  added by Bearer Web Developer end
    return <></>
    // modified by Bearer Web Developer end
}
